import React from 'react';
import classNames from 'classnames';
import { IRulesGroupItemProps } from './RulesGroupItem.types';
import styles from './RulesGroupItem.module.css';

export const RulesGroupItem: React.FC<IRulesGroupItemProps> = ({ children, className }: IRulesGroupItemProps) => {
  return <div className={classNames(styles.rulesGroupItem, className)}>{children}</div>;
};
